
import React, { useState, useMemo } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { X } from 'lucide-react';
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { LANGUAGES } from "@/data/constants";

interface LanguagesSectionProps {
  languagesValue: string[];
  setLanguagesValue: (languages: string[]) => void;
}

const LanguagesSection: React.FC<LanguagesSectionProps> = ({
  languagesValue,
  setLanguagesValue
}) => {
  const availableLanguages = useMemo(() => {
    return LANGUAGES.filter(lang => !languagesValue.includes(lang.label));
  }, [languagesValue]);

  const handleSelectLanguage = (language: string) => {
    if (language && !languagesValue.includes(language)) {
      setLanguagesValue([...languagesValue, language]);
    }
  };

  const removeLanguage = (languageToRemove: string) => {
    setLanguagesValue(languagesValue.filter(language => language !== languageToRemove));
  };

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="space-y-4">
          <div className="flex gap-2">
            <Select
              value=""
              onValueChange={handleSelectLanguage}
            >
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Select a language" />
              </SelectTrigger>
              <SelectContent>
                <div className="max-h-[300px] overflow-y-auto">
                  {availableLanguages.map((language) => (
                    <SelectItem key={language.id} value={language.label}>
                      {language.label}
                    </SelectItem>
                  ))}
                </div>
              </SelectContent>
            </Select>
          </div>

           <div className="flex flex-wrap gap-2">
            {languagesValue.map((language, index) => (
              <Badge key={index} className="group px-3 py-1.5 flex items-center gap-1.5 bg-[#F4F4F5] text-black hover:text-white">
                {language}
                <button
                  onClick={() => removeLanguage(language)}
                  className="ml-1 text-black group-hover:text-white"
                >
                  <X className="h-3 w-3" />
                </button>
              </Badge>
            ))}
            {languagesValue.length === 0 && (
              <p className="text-sm text-muted-foreground">No languages added yet.</p>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default LanguagesSection;
